import { useNavigate } from "react-router-dom";
import { IoArrowBack, IoLanguageOutline, IoLogOutOutline, IoCheckboxOutline } from "react-icons/io5";
import { useI18n } from "@/i18n";
import { useAuth } from "@/auth";

export const AppHeader = ({ title, showBack = false, backTo = null, right = null, onCheck = null, showLogout = false, variant = "" }) => {
  const navigate = useNavigate();
  const { lang, setLang, t } = useI18n();
  const { logout } = useAuth();

  const handleBack = () => {
    if (backTo) navigate(backTo);
    else navigate(-1);
  };

  return (
    <header className={`tf-header-simple ${variant === "fixed" ? "tf-header-fixed" : ""}`} data-testid="app-header">
      <div style={{ minWidth: 44 }}>
        {showBack ? (
          <button
            data-testid="back-button"
            onClick={handleBack}
            className="tf-icon-btn ghost"
            aria-label="Back"
          >
            <IoArrowBack size={20} />
          </button>
        ) : (
          <button
            data-testid="header-lang-toggle"
            onClick={() => setLang(lang === "it" ? "en" : "it")}
            className="tf-icon-btn yellow"
            style={{ width: 62, borderRadius: 20, gap: 4, padding: "0 10px" }}
          >
            <IoLanguageOutline size={16} />
            <span style={{ fontWeight: 800, fontSize: 13 }}>{lang.toUpperCase()}</span>
          </button>
        )}
      </div>
      <div className="tf-header-title-center" data-testid="page-title">{title}</div>
      <div style={{ minWidth: 44, display: "flex", justifyContent: "flex-end", gap: 8 }}>
        {right}
        {showLogout && (
          <button data-testid="logout-btn" onClick={logout} className="tf-icon-btn ghost" aria-label={t("logout")}>
            <IoLogOutOutline size={18} />
          </button>
        )}
        {onCheck && (
          <button
            data-testid="header-select-btn"
            onClick={onCheck}
            className="tf-icon-btn ghost"
            aria-label="Select"
          >
            <IoCheckboxOutline size={20} />
          </button>
        )}
      </div>
    </header>
  );
};
